import Vue from 'vue';
import Router from 'vue-router';
import Docs from '../views/Docs.vue';
import Bookmarked from '../views/Bookmarked.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/docs',
      name: 'docs',
      component: Docs,
    },
    {
      path: '/bookmarked',
      name: 'bookmarked',
      component: Bookmarked,
    },    {
      path: '/confirm/:code',
      name: 'confirm',
      component: () => import(/* webpackChunkName: "test" */ '../views/Confirm.vue'),
    },
    {
      path: '/m/:code',
      name: 'm',
      component: () => import(/* webpackChunkName: "test" */ '../views/MagicURL.vue'),
    },
    {
      path: '/forgotpassword/:code',
      name: 'forgotpassword',
      component: () => import(/* webpackChunkName: "test" */ '../views/ForgotPassword.vue'),
    },
  ],
});

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
  // if the to route doesn't match any defined routes, redirect to /
  if (to.matched.length === 0) {
    console.log(`router.beforeEach() found no matches for ${JSON.stringify(to)}`)
    next('/docs')
  }

  if (to.name && to.name.includes('callback')) { // check if "to"-route is "callback" and allow access
    next();
  } else {
    next();
  }
});

export default router;
